// utils/__api__/auth.ts

export async function loginAction(
  {email,
  password}
) {
  try {

    console.log({ email, password })
    const response = await fetch('/api/login',
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify({ email, password }),
      }
    );

    const data = await response.json();

    if (!response.ok) {
      return {
        success: false,
        status: response.status,
        message: data?.message || "Error al iniciar sesión",
      };
    }

    return {
      success: true,
      status: 200,
      data,
    };
  } catch (error) {
    console.error("Login error:", error);
    return {
      success: false,
      status: 500,
      message: "Error de conexión con el servidor",
    };
  }
}
